import { createContext } from 'react';

export interface ProductTableConfig {
    showPrices: boolean;
    editable: boolean;
    editSurcharges: boolean;
    editPrices: boolean;
    fetchProducts?: () => void;
}

const defaultContextValue: ProductTableConfig = {
    showPrices: true,
    editable: true,
    editSurcharges: true,
    editPrices: true,
    fetchProducts: undefined,
};

export const ProductTableContext = createContext(defaultContextValue);
